import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { RequestService } from 'src/app/services/request/request.service';
import {PermissionsService} from "../../services/permissions/permissions.service";
import {ConstantsService} from "../../services/constants/constants.service";

@Component({
  selector: 'app-pulse-requests-view-recipients',
  templateUrl: './pulse-requests-view-recipients.component.pug',
  styleUrls: ['./pulse-requests-view-recipients.component.scss'],
  standalone: false
})
export class PulseRequestsViewRecipientsComponent implements OnInit {
  totalPulseRecipientsDetails: any[] = [];
  totalRecipients: any;
  typeOfCheck = 'pulse';
  check_uid: any;
  selectedColumns: any = [];
  searchOptionsPulses = [
                         {'label':$localize`Employee`,'hint':$localize`(First or last name)`,'value':'recipient'},
                         {'label':$localize`Email`,'hint':$localize`(Work or personal email)`,'value':'email'},
                         {'label':$localize`Mobile`,'hint':$localize`(Mobile number)`,'value':'mobile'},
                         {'label':$localize`Department`,'hint':$localize`(Department)`,'value':'department'}
                        ];

  searchTitle = ConstantsService.searchTitle;
  searchDescription = ConstantsService.searchDescription;
  searchImg = ConstantsService.searchImg;

  searchOptions = this.searchOptionsPulses
  searchOption: any = undefined;
  addOrder = 0;
  loading = false;
  searchTags: any = [];


  pagination = {
    "rowsPerView": 20,
    "currentPage": 1
  }
  sortCriteria = {
    "sortString": 'recipient',
    "sortOrder": 'desc'
  }

  pulseSortOptions = [
    {
      'label': $localize`Employee`,
      'type': "word",
      'value': "recipient"
    },
    {
      'label': $localize`Department`,
      'type': "word",
      'value': "department"
    }
  ]
  searchTerm = '';
  filterBy = {
    'error': false,
    'warning': false
  };

  constructor(private requestService: RequestService,
    private alertList: AlertBannerService,
    private modalService: BsModalService,
    public permissions: PermissionsService,
    ) {
  }

  ngOnInit(): void {
    this.searchOptionsPulses = [
      {'label':$localize`Employee`,'hint':$localize`First or last name`,'value':'recipient'},
      {'label':$localize`Email`,'hint':$localize`Work or personal email`,'value':'email'},
      {'label':$localize`Mobile`,'hint':$localize`Mobile number`,'value':'mobile'},
      {'label':$localize`Department`,'hint':$localize`Department`,'value':'department'}
    ];
    this.searchOptions = this.searchOptionsPulses
    this.retrievePulseRecipientTableData(this.check_uid);
  }

  retrievePulseRecipientTableData(check_uid) {
    this.requestService.retrievePulseRecipients(check_uid, this.searchOption, this.pagination['rowsPerView'], this.pagination['currentPage'], this.sortCriteria['sortString'], this.sortCriteria['sortOrder'], this.filterBy).subscribe((data: any) => {
        this.loading = true;
        this.totalPulseRecipientsDetails = data['pulses'];
        this.totalRecipients = data['total_pulses'];
      },
      (err: any) => {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
      }
    )

  }

  onSortChange(sortString: any): void {
    if (sortString.includes('-')) {
      this.sortCriteria['sortOrder'] = 'desc';
      this.sortCriteria['sortString'] = sortString.substring(1);
    } else {
      this.sortCriteria['sortOrder'] = 'asc';
      this.sortCriteria['sortString'] = sortString;
    }
    this.retrievePulseRecipientTableData(this.check_uid);
  }
  onPageChange(pageNumber) {
    this.pagination['currentPage'] = pageNumber;
    this.retrievePulseRecipientTableData(this.check_uid);
  }

  onPageSizeChange(rowsPerView) {
    this.pagination['rowsPerView'] = rowsPerView;
    this.pagination['currentPage'] = 1;
    this.retrievePulseRecipientTableData(this.check_uid);
  }

  createSearchOption(): { key: string; value: string }[] {
    return this.searchTags.map(item => ({
      key: item.value === '' ? 'all' : item.value,
      value: item.term
    }));
  }

  onSearchChange(searchOutput) {
    this.loading = false;
    this.searchTags = [...this.searchTags]
    this.searchTags.unshift(searchOutput)
    this.searchOption = this.createSearchOption()

    this.searchOptions = this.searchOptionsPulses;
    this.retrievePulseRecipientTableData(this.check_uid);
  }

  onRemoveSearchTag(searchOutput){
    this.loading = false;
    this.searchTags = searchOutput
    this.searchOption = []
    this.retrievePulseRecipientTableData(this.check_uid);
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
